import Service from './Service';

export default class FloorService extends Service{
    constructor() {
        super();
        this.baseURL = 'floor';
    }
}